var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-components--icon-card",class:{ sticky: _vm.sticky },style:({
    margin: '10px auto 20px auto',
    width: _vm.cardWidth || '100%',
  }),on:{"click":_vm.toggleSticky}},[(_vm.menu)?_c('div',{staticClass:"my-components--icon-card--menu"},_vm._l((Object.keys(_vm.menu)),function(button){return _c('button',{key:button,style:({
        'background-color': ("" + (_vm.menu[button].color)),
      }),on:{"click":function($event){$event.stopPropagation();return (function () { return _vm.menu[button].action(_vm.data); })($event)}}},[_c('span',[_c('font-awesome-icon',{attrs:{"icon":_vm.menu[button].icon}})],1)])}),0):_vm._e(),_c('div',{style:({
      'background-color': _vm.color || 'inherit',
      'width': ((this.sideWidth) + "px")
    })},[(_vm.icon && !_vm.isBreak)?_c('span',[_vm._v(_vm._s(_vm.icon))]):(_vm.faIcon && !_vm.isBreak)?_c('span',{staticClass:"strong"},[_c('font-awesome-icon',{attrs:{"icon":_vm.faIcon}})],1):_vm._e()]),_c('span',{style:({
      'width': ("calc(100% - " + (this.sideWidth) + "px)")
    })},_vm._l((_vm.useDisplayKeys),function(key,index){return _c('span',{key:index,class:{
        altRow: _vm.altRows && _vm.altRows[key],
        sep: key === 'sep' && _vm.data[key] === 'sep',
        'my-card-slot': _vm.data[key] === 'my-card-slot'
      },style:(_vm.computedCardStyles(key, index, _vm.data[key]))},[(_vm.data[key] === 'my-card-slot')?_vm._t(key):_vm._e(),(
          _vm.data[key] !== 'my-card-slot' &&
          (!_vm.hideLabels ||
          (_vm.forceShowLabels &&
            _vm.forceShowLabels.includes(key) &&
            !(key === 'sep' && _vm.data[key] === 'sep')))
        )?_c('strong',[_vm._v(" "+_vm._s(key)+" ")]):_vm._e(),(
          _vm.data[key] !== 'my-card-slot' &&
          !(key === 'sep' && _vm.data[key] === 'sep')
      )?_c('span',[_vm._v(" "+_vm._s(_vm.data[key])+" ")]):_vm._e()],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }